// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"ab445a56","39":"96078049","59":"73ad114a","459":"eecec087","670":"2f1311e0","719":"5b83f005","895":"232d9b73"}[chunkId] + ".chunk.css";
};